import { Controller } from "@hotwired/stimulus";
import { Tracking, UrlParamsHelper } from '../shared/helpers';

export default class extends Controller {
  static targets = ['form'];

  submit() {
    this.handleTracking();
    Turbo.visit(this.url);
  }

  handleTracking() {
    if (window.document.documentMode) return;

    const trackingParams = UrlParamsHelper.convertUrlParamsToObject(this.url);

    const trackingLabels = Object.keys(trackingParams)
      .map(param => {
        let trackingLabel = null;
        if (param === 'ratings[]') {
          trackingLabel = `toggle_min_rating_${trackingParams['ratings[]']}`;
        } else if (param === 'courtesy_car[purchasable]') {
          trackingLabel = 'toggle_courtesy_car_purchasable';
        } else if (param === 'courtesy_car[included]') {
          trackingLabel = 'toggle_courtesy_car_included';
        } else if (param === 'within_business_days') {
          trackingLabel = `toggle_within_business_days_${trackingParams['within_business_days']}`;
        }
        return trackingLabel;
      })
      .filter(label => label !== null);

    trackingLabels.forEach(label => Tracking.action('MyGarage', 'OfferOverview Filtering', label));
  }

  get url() {
    return `${this.formTarget.getAttribute('action')}?${this.serialize(this.formTarget)}`;
  }

  serialize(form) {
    // Setup our serialized data
    let serialized = [];

    // Loop through each field in the form
    for (let i = 0; i < form.elements.length; i++) {
      const field = form.elements[i];

      // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
      if (
        !field.name ||
        field.disabled ||
        field.type === 'file' ||
        field.type === 'reset' ||
        field.type === 'submit' ||
        field.type === 'button'
      )
        continue;

      // If a multi-select, get all selections
      if (field.type === 'select-multiple') {
        for (let n = 0; n < field.options.length; n++) {
          if (!field.options[n].selected) continue;
          serialized.push(
            `${encodeURIComponent(field.name)}=${encodeURIComponent(field.options[n].value)}`
          );
        }
      }

      // Convert field data to a query string
      else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
        serialized.push(`${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`);
      }
    }

    return serialized.join('&');
  }
}
